import type {
  GiftieOnboardingFeature,
  GiftieOnboardingPlacementSurface,
} from '@/types'

export const SHOW_LOGO_ASSETS_CARD = false

export const GREETING_CARD_BUILDER_URL
  = process.env.NEXT_PUBLIC_GREETING_CARD_BUILDER_URL?.replace(/\/$/, '') || ''

export const FEATURE_CARDS: Array<{
  feature: GiftieOnboardingFeature
  title: string
  description: string
  eyebrow: string
}> = [
  {
    feature: 'gift_message',
    title: 'Text gift message',
    eyebrow: 'Core message',
    description:
      'A clean message box for shoppers to write a note with the gift.',
  },
  {
    feature: 'video_messages',
    title: 'Video message and voice note',
    eyebrow: 'Rich media',
    description:
      'Customers can record a video or voice note and share it through a branded playback page.',
  },
  {
    feature: 'greeting_cards',
    title: 'Greeting card builder',
    eyebrow: 'Printed add-on',
    description:
      'Offer a printed card builder with saved designs and upsell-ready card products.',
  },
  {
    feature: 'magic_writer',
    title: 'Magic Writer',
    eyebrow: 'AI assist',
    description:
      'Suggest polished, occasion-aware messages inside the Giftie experience.',
  },
  {
    feature: 'scheduled_sends',
    title: 'Scheduled sends',
    eyebrow: 'Gift calendar',
    description:
      'Customers plan gifts ahead on a calendar and choose when each one arrives.',
  },
]

export const SURFACE_LABELS: Record<
  GiftieOnboardingPlacementSurface,
  string
> = {
  product: 'Product page',
  cart: 'Cart page',
  cart_drawer: 'Cart drawer',
}

export const SURFACE_DESCRIPTIONS: Record<
  GiftieOnboardingPlacementSurface,
  string
> = {
  product: 'Prompt shoppers while they choose the gift.',
  cart: 'Collect the note before checkout starts.',
  cart_drawer: 'Keep gifting inside the slide-out cart flow.',
}

export const FEATURE_CARD_MEDIA: Record<GiftieOnboardingFeature, string> = {
  gift_message: '/admin/selectable-media/feature-gift-message.webp',
  video_messages: '/admin/selectable-media/feature-video-message.webp',
  greeting_cards: '/admin/selectable-media/feature-greeting-card.webp',
  magic_writer: '/admin/selectable-media/feature-magic-writer.webp',
  scheduled_sends: '/admin/selectable-media/feature-scheduled-sends.webp',
}

export const PLACEMENT_CARD_MEDIA: Record<
  GiftieOnboardingPlacementSurface,
  string
> = {
  product: '/admin/selectable-media/placement-product.webp',
  cart: '/admin/selectable-media/placement-cart.webp',
  cart_drawer: '/admin/selectable-media/placement-cart-drawer.webp',
}

export const SURFACE_THEME_TEMPLATES: Partial<
  Record<GiftieOnboardingPlacementSurface, 'product' | 'cart'>
> = {
  product: 'product',
  cart: 'cart',
}

export const HELP_LINKS = {
  demo: 'https://get-giftie.com/?meeting=demo',
  setup: 'https://get-giftie.com/?meeting=setup-call',
}

export const YUZU_GIFTIE_CONNECT_URL
  = process.env.NEXT_PUBLIC_YUZU_GIFTIE_STORE_URL
    ?? 'https://app.yuzu.so/store/giftie'
